export default {
    'global.error': 'Chyba',
    'global.send': 'Odeslat',
    'global.loading': 'Načítání',
    'global.nextStep': 'Další krok',
    'global.previousStep': 'Krok zpět',
    'global.update': 'Upravit',
    'global.delete': 'Smazat',
    'global.remove': 'Odebrat',
    'global.open': 'Otevřít',
    'global.add': 'Přidat',
    'global.duplicate': 'Duplikovat',
    'global.error.notPositiveNumber': 'Hotnota musí být větší než 0',
    'global.error.notInPast': 'Hodnota musí být v minulosti',

    'loginPage.title': 'Přehled typů žádostí o zvláštní užívání komunikací',
    'loginPage.createZadost': 'Nová žádost',
    'loginPage.typZaborSearchHint': 'Vyhledat dle požadovaného účelu záboru',

    'registerBox.title': 'Nemáte ještě vytvořený účet?',
    'registerBox.info.title': 'Registrací do systému získáte:',
    'registerBox.info.line1': 'možnost vytvářet žádosti o zvláštní používání komunikací',
    'registerBox.info.line2': 'přehledně zjistit stav vyřizování podaných žádostí',
    'registerBox.info.line3': 'systém Vám bude zasílat důležitá upozornění související s podanými žádostmi',
    'registerBox.createAcc': 'Vytvořit účet',

    'registerForm.info': 'K přístupu do systému zadávání žádostí a další komunikaci s úřadem je potřeba zadat emailovou adresu. A pro přihlášení zadat heslo.',
    'registerForm.notSamePasswords': 'Hesla nejsou stejná',
    'registerForm.email': 'Email',
    'registerForm.password': 'Heslo',
    'registerForm.passwordAgain': 'Heslo znovu',
    'registerForm.firstname': 'Jméno',
    'registerForm.lastname': 'Příjmení',
    'registerForm.submit': 'Registrovat',

    'loginForm.invalidLogin': 'Neplatné uživatelské jméno nebo heslo.',

    'newPasswordForm.info': 'Zadejte Vaše nové heslo',
    'newPasswordForm.password': 'Heslo',
    'newPasswordForm.passwordAgain': 'Heslo znovu',
    'newPasswordForm.notSamePasswords': 'Hesla nejsou stejná',

    'loginForm.title': 'Přihlášení',
    'loginForm.username': 'Přihlašovací email',
    'loginForm.password': 'Heslo',
    'loginForm.lostPassword': 'Zapomenuté heslo',
    'loginForm.submit': 'Přihlásit',

    'passwordRecoveryForm.info': 'Pokud je tento email zaregistrován, bude na něj zaslána žádost o obnovení hesla.',
    'passwordRecoveryForm.userNotExist': 'Uživatel neexistuje!',
    'passwordRecoveryForm.email': 'Email',
    'passwordRecoveryForm.submit': 'Zažádat o obnovu hesla',

    'zadostStateCheck.notFound': 'Žádost nebyla nalezena.',
    'zadostStateCheck.title': 'Zjištění stavu žádosti',
    'zadostStateCheck.stateInfo': 'Stav vyřizování žádosti s referenčním číslem',
    'zadostStateCheck.refNumber': 'Referenční číslo',
    'zadostStateCheck.submit': 'Zjistit stav',

    'toastr.registerDone': 'Pro dokončení registrace klikněte na odkaz zaslaný v emailu.',
    'toastr.recoveryPass': 'Email byl odeslán.',
    'toastr.clickToEditProfile': 'Kliknutím zde můžete editovat svůj profil',

    'modal.passRecovery': 'Obnova hesla',
    'modal.register': 'Nový účet',
    'modal.userSubjekt': 'Subjekt',

    'zadostTyp.title': 'Zvolte typ žádosti podle účelu záboru',
    'zadostTyp.searchHint': 'Vyhledat dle požadovaného účelu záboru',
    'zadostTyp.typZaborPrompt': 'Vyberte typ záboru',

    'zadostNalezitosti.title': 'Vyplňte požadované informace a vložte požadované přílohy',
    'zadostNalezitosti.attacheFile': 'Přiložit soubor',
    'zadostNalezitosti.declaration.L': 'Doloženo v listinné podobě',
    'zadostNalezitosti.declaration.N': 'Nebude dokládáno (není potřeba)',
    'zadostNalezitosti.relatedLink': 'Související odkaz',
    'zadostNalezitosti.applicant': 'Žadatel',
    'zadostNalezitosti.requiredInfo': 'Požadované informace:',
    'zadostNalezitosti.requiredAttachments': 'Požadované přílohy:',

    'zadostZakres.title': 'Zakreslete do mapy požadované lokality a jejich účely využití',
    'zadostZakres.applicant': 'Žadatel',
    'zadostZakres.info': 'Pro přidání další lokality zvolte příslušný nástroj ikonou v mapě. O ZUK lze žádat pouze mimo veřejnou zeleň a silnice I. třídy',
    'zadostZakres.noApplicant': 'Žadatel nebyl vyplněn!',

    'zadostShrnuti.title': 'Shrnutí žádosti',
    'zadostShrnuti.pdfPreview': 'Zobrazit náhled žádosti v PDF',
    'zadostShrnuti.requiredAttachments': 'Požadované přílohy:',
    'zadostShrnuti.applicant': 'Žadatel',
    'zadostShrnuti.noApplicant': 'Je potřeba vyplnit údaje subjektu Žadatel.',
    'zadostShrnuti.typZadost': 'Typ žádosti:',
    'zadostShrnuti.popis': 'Popis:',
    'zadostShrnuti.ucely': 'Účely:',
    'zadostShrnuti.requiredInfo': 'Požadované informace:',
    'zadostShrnuti.refNumber': 'Referenční číslo:',
    'zadostShrnuti.relatedLink': 'Související odkaz',
    'zadostShrnuti.accept': 'Potvrdit žádost a uzavřít změny',
    'zadostShrnuti.accept.confirm.title': 'Potvrdit žádost a uzavřít změny?',
    'zadostShrnuti.accept.confirm.message': 'Žádost již nebude možné dále upravovat.',
    'zadostShrnuti.accept.done.title': 'Uzavření žádosti',
    'zadostShrnuti.accept.done.message': 'Žádost byla uzavřena a je evidována pod referenčním číslem ',
    'zadostShrnuti.accept.done.messagedoruceni': 'Žádost je nyní potřeba vytisknout a doručit oficiální cestou na podatelnu úřadu současně s dalšími potřebnými přílohami. Případně lze žádost podat prostřednictvím datové schránky.',
    'zadostShrnuti.accept.done.message.button': 'Zde si můžete stáhnout PDF soubor žádosti pro tisk',
    'zadostShrnuti.accept.done.databox.button': 'Přejít do datové schránky',
    'zadostShrnuti.declaration.L': 'Doloženo v listinné podobě',
    'zadostShrnuti.declaration.N': 'Nebude dokládáno (není potřeba)',
    'zadostShrnuti.declaration.D': 'Soubor přiložen',
    'zadostShrnuti.declaration.undecidedErr': 'Nutno zvolit jak bude dodána příloha.',
    'zadostShrnuti.noRoleSubjekt': 'Je potřeba vyplnit údaje subjektu {0}.',

    'zadostLayout.stage.1': '1. Výběr typu žádosti',
    'zadostLayout.stage.2': '2. Náležitosti a přílohy',
    'zadostLayout.stage.3': '3. Zakreslení lokalit do mapy',
    'zadostLayout.stage.4': '4. Shrnutí',

    'zadostRozhodnuti.N': 'Nerozhodnuto',
    'zadostRozhodnuti.S': 'Schváleno',
    'zadostRozhodnuti.P': 'Předběžně schváleno',
    'zadostRozhodnuti.Z': 'Zamítnuto',

    'typUcel.DZ': 'Dopravní značení',
    'typUcel.UZAVIRKA': 'Uzavírka',
    'typUcel.ZUK': 'Zábor',
    'typUcel.PRIPOJENIKOMUNIKACE': 'Připojení na komunikaci',
    'typUcel.VRAKY': 'Vraky',
    'typUcel.VYJIMKY': 'Výjmka',
    'typUcel.STAVBNICINNOST': 'Překážky, reklamní zařízení',

    'passwordRecoverForm.info': 'Zadejte registrovaný e-mail na který pošleme link pro obnovení hesla',

    'subjektForm.udajeSubjektu': 'Údaje subjektu',
    'subjektForm.odpovednaOsoba': 'Odpovědná osoba',
    'subjektForm.odpovednaOsoba.add': 'Přidat odpovědnou osobu',
    'subjektForm.dorucovaciAdresa': 'Doručovací adresa',
    'subjektForm.verifyResult.success': 'Subjekt ověřen.',
    'subjektForm.verifyResult.none': 'Nenalezen žádný odpovídající subjekt.',
    'subjektForm.verifyResult.many': 'Nalezen více než jeden odpovídající subjekt.',

    'obdobi': 'Období',
    'obdobi.type': 'Typ',
    'obdobi.type.day': 'Den',
    'obdobi.type.interval': 'Období',
    'obdobi.day': 'Den',
    'obdobi.start': 'Od',
    'obdobi.startDate': 'Datum od',
    'obdobi.startTime': 'Čas od',
    'obdobi.end': 'Do',
    'obdobi.endDate': 'Datum do',
    'obdobi.endTime': 'Čas do',
    'obdobi.add': 'Přidat období',
    'obdobi.remove': 'Odebrat období',
    'obdobi.more': 'Více období...',
    'obdobi.emptyList': 'Seznam období je prázdný.',
    'obdobi.upresneni': 'Upřesnění (např. který den v týdnu, opakovaní apod.)',
    'obdobi.missingDate': 'Není vyplněno datum',
    'obdobi.missingOneOfTimes': 'Je vyplněn pouze jeden z časů',
    'obdobi.sameStartEndDateTime': 'Koncový datum a čas je stejný jako počáteční',
    'obdobi.endBeforeStartDateTime': 'Koncový datum a čas předchází počátečnímu',
    'obdobi.endBeforeStartDate': 'Koncový datum předchází počátečnímu',
    'obdobi.dateTimFromPast': 'Zadejte budoucí datum a čas',

    'lokalita.title': 'Lokalita',
    'lokalita.list': 'Lokality',
    'lokalita.emptyList': 'Není zakreslena žádna lokalita!',

    'lokalita.obdobiList': 'Období',
    'lokalita.druhUcel': 'Kategorie',
    'lokalita.popisUcel': 'Účel',
    'lokalita.delka': 'Délka',
    'lokalita.sirka': 'Šířka',
    'lokalita.plocha': 'Plocha',
    'lokalita.provozovna': 'Provozovna',
    'lokalita.identifikace': 'Umístění',
    'lokalita.identifikace.zakresHint': 'Proveďte zákres do mapy pro vygenerování adresy.',
    'lokalita.identifikace.upravaHint': 'Není nastavena adresa, proveďtě úpravu.',
    'lokalita.identifikace.edit': 'Upravit',
    'lokalita.identifikace.edit.manual': 'Upravit ručně',
    'lokalita.identifikace.edit.load': 'Vygenerovat ze zákresu',
    'lokalita.identifikace.loading': 'Probíhá identifikace adresy...',
    'lokalita.identifikace.error': 'Nepodařilo se identifikovat adresu.',
    'lokalita.definice': 'Upřesnění umístění',
    'lokalita.definice.loading': 'Probíhá generování zákresu dle adresy...',
    'lokalita.definice.zakresHint': 'Zapište adresu pro automatické vygenerování zákresu.',
    'lokalita.geodata.hint': 'Proveďte zákres do mapy.',

    'dokument.list': 'Dokumenty',
    'dokument.emptyList': 'Seznam dokumentů je prázdný',

    'typZabor.zadatel': 'Žadatel',
    'typZabor.emptyList': 'Nenalezen žádný typ záboru.',

    'zadost.list.title': '',
    'zadost.deletion.title': 'Smazání žádosti',
    'zadost.deletion.confirm': 'Opravdu smazat žádost s referenčním číslem {0}?',
    'zadost.edit': 'Pokračovat v úpravě',
    'zadost.print.pdf': 'Oficiální žádost (PDF)',
    'zadost.print.rtf': 'MS Word',
    'zadost.add': 'Přidat žádost',
    'zadost.cislo': 'Číslo',
    'zadost.typ': 'Typ',
    'zadost.obdobi': 'Období',
    'zadost.stav': 'Stav',
    'zadost.akce': 'Akce',
    'zadost.stav.R': 'Rozpracovaná',
    'zadost.stav.V': 'Uzavřená',
    'zadost.rozhodnuti.N': 'Nerozhodnuto',
    'zadost.rozhodnuti.S': 'Schváleno',
    'zadost.rozhodnuti.P': 'Předběžně schváleno',
    'zadost.rozhodnuti.Z': 'Zamítnuto',
};
